import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { TutorialCardProps } from ".";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { DialogDescription } from "@radix-ui/react-dialog";
import { useState } from "react";
import { TutorialDialog } from "../TutorialDialog/TutorialDialog";

export function TutorialCard({
    title,
    description,
    scribeHowEmbedLink = ''
}: Readonly<TutorialCardProps>) {
    const [loading, setLoading] = useState(true);

    return (
        <div className="flex items-center justify-between w-full gap-2 p-4 bg-white border border-gray-300 rounded-lg">
            <div className="flex flex-col">
                <div className="flex items-center gap-1">
                    {/* <ClipboardPen size="16" /> */}
                    <h3 className="text-sm font-semibold">{title}</h3>
                </div>
                <p className='text-xs text-gray-500'>
                    {description}
                </p>
            </div>

            <TutorialDialog
                title={title}
                description={description}
                scribeHowEmbedLink={scribeHowEmbedLink}
                dialogTrigger={(
                    <DialogTrigger asChild>
                        <Button size="sm">
                            See How <ChevronRight size={16} />
                        </Button>
                    </DialogTrigger>
                )}
            />
        </div>
    )
}
